// extracted by mini-css-extract-plugin
export var standaloneTable = "_gr-0";
export var standaloneTableWithBodyFill = "_gr-1";
export var withExtraHeader = "_gr-2";